module.exports = __webpack_public_path__ + "assets/img/white.0f602998.png";